var _g, _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiveicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3009_7729)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.3335,
    cy: 14,
    r: 11.8333,
    stroke: "url(#paint0_radial_3009_7729)",
    strokeWidth: 0.333333
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.667,
    cy: 14,
    r: 9.66666,
    stroke: "white",
    strokeWidth: 0.666666
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5002 4.33301C14.7462 4.33301 15.9803 4.58244 17.1321 5.06735C18.2839 5.55227 19.3312 6.26333 20.2139 7.16046C21.0965 8.05761 21.7973 9.12328 22.2756 10.2969C22.7539 11.4705 23.0002 12.7287 23.0002 13.9997C23.0002 15.2706 22.7539 16.5289 22.2756 17.7025C21.7973 18.8761 21.0965 19.9417 20.2139 20.8389C19.3312 21.736 18.2839 22.4471 17.1321 22.932C15.9803 23.4169 14.7462 23.6663 13.5002 23.6663C12.2541 23.6663 11.02 23.4169 9.86823 22.932C8.71641 22.4471 7.66913 21.736 6.78646 20.8389C5.90378 19.9417 5.20303 18.8761 4.72475 17.7025C4.24647 16.5289 4.00016 15.2706 4.00016 13.9997C4.00016 12.7287 4.24647 11.4705 4.72476 10.2969C5.20304 9.12328 5.90378 8.05761 6.78647 7.16046C7.66913 6.26333 8.71641 5.55227 9.86823 5.06735C11.02 4.58244 12.2541 4.33301 13.5002 4.33301L13.5002 4.33301Z",
    stroke: "url(#paint1_radial_3009_7729)",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7293 16.7916C12.8581 16.7916 12.197 16.4649 11.7226 15.9671L12.3059 15.2749C12.7104 15.6794 13.2004 15.9516 13.737 15.9516C14.3904 15.9516 14.8104 15.5316 14.8104 15.0105C14.8104 14.466 14.3748 14.1005 13.737 14.1005C13.317 14.1005 12.9593 14.2405 12.6559 14.4738L11.9948 14.1938L12.0726 11.3549H15.487V12.2416H12.9748L12.9359 13.6182C13.2081 13.4316 13.5581 13.2916 14.0093 13.2916C14.9659 13.2916 15.7748 13.8982 15.7748 14.9716C15.7748 16.076 14.9426 16.7916 13.7293 16.7916Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3009_7729",
    x: 0.00016284,
    y: 0.666667,
    width: 26.6667,
    height: 26.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.666667,
    result: "effect1_foregroundBlur_3009_7729"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3009_7729",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.59156 18.1311) rotate(-25.594) scale(18.6707 102.048)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF421D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883DD2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3009_7729",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.0002 20.6663) rotate(-115.233) scale(16.0295 86.7163)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF421D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883DD2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiveicon);
export default __webpack_public_path__ + "static/media/fiveicon.b3139f32bc98bea04a66e1f7da5f5870.svg";
export { ForwardRef as ReactComponent };